package com.shadowings.gero.data.lessons.chapter15

import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.data.repository.SentenceOptions
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.model.Verb
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_un_seguace_eccellente_1
import gero.composeapp.generated.resources.exp_content_un_seguace_eccellente_2
import gero.composeapp.generated.resources.exp_content_un_seguace_eccellente_3
import gero.composeapp.generated.resources.exp_content_un_seguace_eccellente_4
import gero.composeapp.generated.resources.exp_content_un_seguace_eccellente_5
import gero.composeapp.generated.resources.exp_content_un_seguace_eccellente_6
import gero.composeapp.generated.resources.exp_content_un_seguace_eccellente_7
import gero.composeapp.generated.resources.exp_content_un_seguace_eccellente_8
import gero.composeapp.generated.resources.exp_content_un_seguace_eccellente_9
import gero.composeapp.generated.resources.exp_content_un_seguace_eccellente_10
import gero.composeapp.generated.resources.exp_content_un_seguace_eccellente_11
import gero.composeapp.generated.resources.exp_content_un_seguace_eccellente_12
import gero.composeapp.generated.resources.exp_content_un_seguace_eccellente_13
import gero.composeapp.generated.resources.exp_title_un_seguace_eccellente
import kotlin.random.Random

fun getUnSeguaceEccellenteContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_un_seguace_eccellente,
            content = Res.string.exp_content_un_seguace_eccellente_1,
            face = Faces.Happy,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_un_seguace_eccellente,
            content = Res.string.exp_content_un_seguace_eccellente_2,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_un_seguace_eccellente,
            content = Res.string.exp_content_un_seguace_eccellente_3,
            face = Faces.Happy,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_un_seguace_eccellente,
            content = Res.string.exp_content_un_seguace_eccellente_4,
            face = Faces.Surprised,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_un_seguace_eccellente,
            content = Res.string.exp_content_un_seguace_eccellente_5,
            face = Faces.Surprised,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_un_seguace_eccellente,
            content = Res.string.exp_content_un_seguace_eccellente_6,
            face = Faces.Serious,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_un_seguace_eccellente,
            content = Res.string.exp_content_un_seguace_eccellente_7,
            face = Faces.Doubt,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_un_seguace_eccellente,
            content = Res.string.exp_content_un_seguace_eccellente_8,
            face = Faces.Surprised,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_un_seguace_eccellente,
            content = Res.string.exp_content_un_seguace_eccellente_9,
            face = Faces.Surprised,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_un_seguace_eccellente,
            content = Res.string.exp_content_un_seguace_eccellente_10,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_un_seguace_eccellente,
            content = Res.string.exp_content_un_seguace_eccellente_11,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_un_seguace_eccellente,
            content = Res.string.exp_content_un_seguace_eccellente_12,
            face = Faces.Perfect,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_un_seguace_eccellente,
            content = Res.string.exp_content_un_seguace_eccellente_13,
            face = Faces.Perfect,
            character = Characters.Alyn,
        )
    )
}

// Chapter 15 review: 4 inscription photos (from all three name lessons) + 3 questions on the
// chapter's new signs + 3 on the NOMI_E_AGGETTIVI_1 vocabulary.
fun getUnSeguaceEccellenteQuizContent(
    hiero: List<Hiero>,
    words: List<Word> = emptyList(),
    verbs: List<Verb> = emptyList(),
    languageCode: String,
    verbSentences: List<SentenceOptions> = emptyList(),
    random: Random = Random
): List<IQuizContent> {
    val inscriptions = (
        getNomiImportantiQuizContent(words) +
            getTraduciamoINomiImageQuizContent(words) +
            getNomiNomiNomiImageQuizContent(words)
        ).shuffled(random).take(4)

    val signs = (
        getUnAttimoQuizContent(hiero, languageCode).shuffled(random).take(1) +
            getSignificatoDeiNomiQuizContent(
                hiero = hiero,
                words = words,
                verbs = verbs,
                languageCode = languageCode,
                verbSentences = verbSentences,
                random = random
            ).take(significatoDeiNomiHieroCodes.size).shuffled(random).take(1) +
            getSegniVariQuizContent(hiero, languageCode).shuffled(random).take(1)
        )

    val vocab = getNomiEAggettivi1QuizContent(words, languageCode, random).take(3)

    return (inscriptions + signs + vocab).shuffled(random)
}
